import { FC, SVGProps } from 'react'
import { ReactComponent as ArrowDown } from 'transfix-icons/icons/ArrowDown.svg'
import { ReactComponent as ArrowUp } from 'transfix-icons/icons/ArrowUp.svg'
import { ReactComponent as DryVan } from 'transfix-icons/icons/DryVan.svg'
import { ReactComponent as LocationFilled } from 'transfix-icons/icons/LocationFilled.svg'
import { ReactComponent as LocationPin } from 'transfix-icons/icons/LocationPin.svg'
import { ReactComponent as People } from 'transfix-icons/icons/People.svg'
import { ReactComponent as Search } from 'transfix-icons/icons/Search.svg'
import { ReactComponent as SortDown } from 'transfix-icons/icons/SortArrowDown.svg'
import { ReactComponent as SortUp } from 'transfix-icons/icons/SortUp.svg'
import { ReactComponent as User } from 'transfix-icons/icons/User.svg'

const INPUT_ICONS = {
  User,
  Search,
  People,
  DryVan,
  LocationPin,
  LocationFilled,
  SortUp,
  SortDown,
  ArrowUp,
  ArrowDown,
} as const

export type TInputIcon = keyof typeof INPUT_ICONS

export const getInputIcon = (
  keyName: TInputIcon | undefined
): FC<SVGProps<SVGSVGElement>> | undefined => {
  if (!keyName || !INPUT_ICONS[keyName]) {
    return undefined
  }

  return INPUT_ICONS[keyName]
}
